import { PaginationItem } from 'aos-ds/src/patterns/paginationitem/PaginationItem'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import { HStack } from '../hstack'
import { Pressable } from '../pressable'

// Carousel dot row. Every slot is an aos-ds `PaginationItem` (Figma 11962:158439),
// which is the component the web "Modal / What's new" (11962:157874) and the
// mobile What's-new sheet (11989:128581) both bind — a 20x10 slot holding a
// 10x10 `content/default` circle, or a 20x10 `primary/default` pill when active.
// Controlled: the parent owns `activeIndex`.
//
// Used standalone where the surrounding view supplies its own paging controls
// (mobile onboarding, the What's-new sheet), and composed by `CarouselIndicator`,
// which flanks it with arrow buttons.

export type CarouselDotsProps = {
    count: number
    activeIndex: number
    onDotPress?: (index: number) => void
    className?: string
    testID?: string
}

export const CarouselDots: React.FC<CarouselDotsProps> = ({
    count,
    activeIndex,
    onDotPress,
    className,
    testID,
}) => (
    <HStack testID={testID} className={twMerge('items-center gap-2', className)}>
        {Array.from({ length: count }).map((_, index) => {
            const isActive = index === activeIndex
            const item = <PaginationItem variant={isActive ? 'pill' : 'dot'} />
            return onDotPress ? (
                <Pressable
                    key={index}
                    onPress={() => onDotPress(index)}
                    accessibilityRole='button'
                    accessibilityState={{ selected: isActive }}
                >
                    {item}
                </Pressable>
            ) : (
                <React.Fragment key={index}>{item}</React.Fragment>
            )
        })}
    </HStack>
)
CarouselDots.displayName = 'CarouselDots'
